import { FC, useCallback, useState } from "react";

import truncate from "lodash/truncate";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import styles from "./style";

import { LINK_PROPERTIES } from "sections/userProfile/LinksForm/config";

import Button from "components/CustomButton";
import ImageNext from "components/ImageNext";
import CustomLink from "components/CustomLink";

import { Link } from "interfaces/Link.interface";

import { urlSchema } from "utils/regex";

interface SectionLinksProps {
  links: Link[];
}

const SectionLinks: FC<SectionLinksProps> = ({ links }) => {
  const [isExpanded, setExpanded] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const isTablet = useMediaQuery(theme.breakpoints.up("md"));

  const handleShowMore = useCallback(() => {
    setExpanded((prevState) => !prevState);
  }, []);

  const SHOW_LIMIT = isDesktop ? 8 : isTablet ? 4 : 3;

  const linksToShow = isExpanded ? links : links?.slice(0, SHOW_LIMIT);

  return (
    <Box className="uniqly-section-links">
      <Box py={1} sx={styles.box}>
        {linksToShow.map((item, index) => {
          const linkProperty =
            LINK_PROPERTIES[item.name] || LINK_PROPERTIES.CUSTOM;

          const url = (item.url || "").replace(urlSchema, "");
          const trunacatedUrl = truncate(url, { length: 30 });

          return (
            <CustomLink
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={styles.link}
              key={`item-${index}`}
              noDecoration
            >
              <ImageNext
                width={24}
                height={24}
                src={linkProperty.icon}
                alt=""
                boxProps={{
                  sx: {
                    maxWidth: 24,
                  },
                }}
              />
              <Box>
                <Typography variant="h4" gutterBottom>
                  {linkProperty.name || item.name}
                </Typography>
                <Typography variant="subtitle2">{trunacatedUrl}</Typography>
              </Box>
            </CustomLink>
          );
        })}
      </Box>
      {links && links.length > SHOW_LIMIT && (
        <Box display="flex" justifyContent="center" mx="auto" width="30%">
          <Button simple onClick={handleShowMore} sx={styles.button}>
            {isExpanded ? (
              <>
                view less
                <KeyboardArrowRightIcon />
              </>
            ) : (
              <>
                view more
                <KeyboardArrowDownIcon />
              </>
            )}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default SectionLinks;
